import React from 'react';
import PropTypes from 'prop-types';
import { TreeViewProvider } from './context/TreeViewProvider';
import TreeViewItem from './TreeItem/TreeViewItem';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
function TreeView(props) {
  const {
    treeNodes = [],
    onChange = () => {},
    onExpand = () => {},
    onSelect = () => {},
    checkedKeys = [],
    expandedKeys = [],
    selectedKeys = [],
    checkable = false,
    collapsible = true,
    expandAll = false,
    selectable = true,
    multiSelect = false,
    autoCheck = {},
    autoUnCheck = {},
    className = '',
    styles = {}
  } = props;
  return /*#__PURE__*/React.createElement(TreeViewProvider, {
    treeNodes: treeNodes,
    checkedKeys: checkedKeys,
    expandedKeys: expandedKeys,
    selectedKeys: selectedKeys,
    expandAll: expandAll,
    autoCheck: autoCheck,
    autoUnCheck: autoUnCheck,
    checkable: checkable
  }, /*#__PURE__*/React.createElement("ul", {
    className: `${treeStyles['sib-tree-view']} ${className}`,
    style: styles,
    role: "tree"
  }, treeNodes.map(function () {
    let treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let i = arguments.length > 1 ? arguments[1] : undefined;
    return /*#__PURE__*/React.createElement(TreeViewItem, {
      key: treeNode.id || i,
      treeNode: treeNode,
      collapsible: collapsible,
      onChange: onChange,
      onExpand: onExpand,
      onSelect: onSelect,
      checkable: checkable,
      selectable: selectable,
      multiSelect: multiSelect,
      expandAll: expandAll
    });
  })));
}
TreeView.propTypes = {
  treeNodes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string,
    helpButtonMetaData: PropTypes.object,
    nodeItem: PropTypes.func,
    disabled: PropTypes.bool,
    children: PropTypes.array
  })),
  onChange: PropTypes.func,
  onExpand: PropTypes.func,
  onSelect: PropTypes.func,
  checkedKeys: PropTypes.array,
  expandedKeys: PropTypes.array,
  selectedKeys: PropTypes.array,
  checkable: PropTypes.bool,
  selectable: PropTypes.bool,
  multiSelect: PropTypes.bool,
  collapsible: PropTypes.bool,
  expandAll: PropTypes.bool,
  autoCheck: PropTypes.object,
  autoUnCheck: PropTypes.object,
  className: PropTypes.string,
  styles: PropTypes.object
};
export default TreeView;